<template>
  
        <v-dialog 
        v-model="dialog" 
        fullscreen transition="dialog-bottom-transition">
            <template 
            v-slot:activator="{ on }">
                <v-btn 
                color="primary"
                            class="mt-3 ml-3"
                dark v-on="on">Registrieren</v-btn>
            </template>
            <v-container 
            fluid class="mt-12">
                <v-row>
                    <v-col 
                    class="col-12">
                        <v-toolbar 
                        dense
                        dark
                        color="secondary">
                        <v-toolbar-title>
                            Registrieren
                        </v-toolbar-title>
                        </v-toolbar>
                       <v-card tile>  
                               <v-card-text>
                             
  <form>
    <v-text-field
      v-model="name"
      :error-messages="nameErrors"
      :counter="10"
      label="Name"
      required
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
    ></v-text-field>
    <v-text-field
      v-model="email"
      :error-messages="emailErrors"
      label="E-mail"
      required
      @input="$v.email.$touch()"
      @blur="$v.email.$touch()"
    ></v-text-field>
    <v-select
      v-model="select"
      :items="items"
      :error-messages="selectErrors"
      label="Item"
      required
      @change="$v.select.$touch()"
      @blur="$v.select.$touch()"
    ></v-select>
    <v-checkbox
      v-model="checkbox"
      :error-messages="checkboxErrors"
      label="Do you agree?"
      required
      @change="$v.checkbox.$touch()"
      @blur="$v.checkbox.$touch()"
    ></v-checkbox>

    <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn 
                                outline
                                tile 
                                text
                                @click="dialog = false">Abbrechen</v-btn>
                                <v-btn 
                                color="secondary" 
                                dark
                                tile
                                @click="submit">Registrieren</v-btn>
                            </v-card-actions>
  </form>
  </v-card-text>
                              

                       </v-card>
                     </v-col>
                </v-row>
            </v-container>
        </v-dialog>

</template>
<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email } from 'vuelidate/lib/validators'

  export default {
    name: "Registrieren",
    mixins: [validationMixin],

    validations: {
      name: { required, maxLength: maxLength(10) },
      email: { required, email },
      select: { required },
      checkbox: {
        checked (val) {
          return val
        },
      },
    },

    data: () => ({
         dialog: false,
      name: '',
      email: '',
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
    }),

    computed: {
      checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        !this.$v.checkbox.checked && errors.push('You must agree to continue!')
        return errors
      },
      selectErrors () {
        const errors = []
        if (!this.$v.select.$dirty) return errors
        !this.$v.select.required && errors.push('Item is required')
        return errors
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.name.required && errors.push('Name is required.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        return errors
      },
    },

    methods: {
      submit () {
        this.$v.$touch()
      },
      clear () {
        this.$v.$reset()
        this.name = ''
        this.email = ''
        this.select = null
        this.checkbox = false
      },
    },
  }
</script>